import * as React from 'react';
import { _PortalState } from 'src/helpers/state';
// import './mp.css'

declare const amp: any;
let videoNode: any;
let player: any;

class AzureMP extends React.Component<IAzureMPProps, {}> {

  constructor(props) {
    super(props);
    videoNode = React.createRef();
  }

  public componentDidMount() {
    const myOptions = {
      "nativeControlsForTouch": false,
      "logo": { "enabled": false },
      controls: true,
      autoplay: false,
      width: "100%",
      // height: "400",
    }
    player = amp(videoNode.current, myOptions);
    player.src(
      [
        {
          "src": this.props.src,
          "type": "application/vnd.ms-sstr+xml",
          "streamingFormats":
            [
              "SMOOTH",
              "DASH"
            ],
          "protectionInfo": [
            {
              "type": "AES",
              "authenticationToken": "Bearer " + this.props.token
            }
          ],
        },
        {
          "src": _PortalState.ApiEndpoint + "/api/Manifest?playbackUrl=" + this.props.src + "(format=m3u8-aapl)&webtoken=Bearer%3d" + this.props.token,
          "type": "application/vnd.apple.mpegurl",
          "disableUrlRewriter": true
        }
      ]
    );
  }

  public render() {

    return (

      <div style={{ width: '100%', margin: 'auto' }}>
        <video ref={videoNode} className="azuremediaplayer amp-default-skin amp-big-play-centered" />
      </div>
    );
  }
}

export default AzureMP

interface IAzureMPProps {
  token: string;
  src: string;
}


// WEBPACK FOOTER //
// ./src/components/video/mp/mp.tsx